import RequireSuperAdminMiddleware from 'middlewares/RequireSuperAdminMiddleware'

export default [
    {
        path: '/admin/claim-your-profile',
        name: 'admin.claim-your-profile',
        view: 'admin/ClaimYourProfile',
        default: { query: { status: 'all' } },
        middlewares: [RequireSuperAdminMiddleware],
    },
    {
        path: '/admin/invites-member/invite-by-email',
        name: 'admin.invite-by-email',
        view: 'admin/InvitesMemberByEmail',
        middlewares: [RequireSuperAdminMiddleware],
    },
    {
        path: '/admin/invites-member/invite-by-phone',
        name: 'admin.invite-by-phone',
        view: 'admin/InvitesMemberByPhone',
        middlewares: [RequireSuperAdminMiddleware],
    },
]
